import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import { approveLaborSheet } from 'actionCreators/phase_items';
import { updatePhaseTask } from 'actionCreators/phase';
import { clearValidation } from 'actionCreators';
import Loading from 'components/Loading';
import ApprovalSignature from './approveLabor/approvalSignature';
import TermsAndName from './approveLabor/termsAndName';
import S from 'modal.scss';
import styles from 'styles/input.scss';

class ApproveLaborModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    approveTerms: false,
    contractorSignature: '',
    contractorName: '',
    errors: {},
    tab: 1,
  }

  static VALIDATIONS = {
    contractorSignature: true,
    contractorName: true,
    approveTerms: true,
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  updateFormData = (approveLaborData) => {
    this.setState(approveLaborData, () => {
      if (approveLaborData.tab === 3) {
        const { contractorName: name, contractorSignature: signature } = this.state;
        this.props.approveLaborSheet(
          this.props.phaseId, this.props.laborSheetId, { name, signature },
        ).then(() => {
          this.handleClose();
        }).catch(() => { });
      }
    });
  }

  showTab = () => {
    switch (this.state.tab) {
      case 1:
        return (<TermsAndName
          phase={this.props.phase}
          updateFormData={this.updateFormData}
          approveTerms={this.state.approveTerms}
          contractorName={this.state.customerName}
        />);
      case 2:
        return (<ApprovalSignature
          phase={this.props.phase}
          updateFormData={this.updateFormData}
          contractorSignature={this.state.contractorSignature}
        />);
      default:
        return (<Loading />);
    }
  }

  render() {
    return (
      <Dialog
        active={this.props.active}
        className={S.modal}
        type="fullscreen"
        onEscKeyDown={this.handleClose}
      >
        <div className={styles.errored}>
          {this.props.errors && Object.keys(this.props.errors).length > 0 &&
            <span className={styles.error}>This action could not be completed.</span>}
        </div>
        <IconButton
          icon="close"
          className={S.close}
          onClick={this.handleClose}
          tabIndex={-1}
        />
        <h5 className={S.title}>Approve Labor</h5>
        {this.showTab()}
      </Dialog>
    );
  }
}

ApproveLaborModal.propTypes = {
  phaseId: PropTypes.number.isRequired,
  laborSheetId: PropTypes.number.isRequired,
  approveLaborSheet: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  errors: PropTypes.object,
};


export default connect(state => ({ errors: state.phase.laborSheets.errors }), {
  approveLaborSheet,
  updatePhaseTask,
  clearValidation,
})(ApproveLaborModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/approveLaborModal.jsx